











































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/PreparacionEquipos/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/PreparacionEquipos/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/PreparacionEquipos/ModalAsignacion.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    MantenedorGrid,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class ModalRequerimiento extends Vue {
  @Prop({ required: true, default: {} }) data: any;

  verfechabateria: boolean = false;
  verfechaplataforma: boolean = false;
  pagina: number = 1;
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  filtrobusquedagrilla: string = '';
  listaReq: any[] = [];
  listaEquipos: any[] = [];
  id_editar: string = '';
  editandoando: boolean = false;
  disabledFieldSerie: boolean = false;
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  showModalNew: boolean = false;
  showModalAsignacion: boolean = false;
  isEdit: boolean = false;
  listaAVL: any[] = [];
  listaModalidad: any[] = [];
  listaEstadoSim: any[] = [];
  deshabilitar: boolean = false;
  btnDisabled: boolean = false;
  currentDate: any = {};
  param: any = {};
  dialogDevolverSeriado: boolean = false;

  mounted() {
    this.initialFieldValues();
  }

  initialFieldValues() {
    for (let key in this.data) {
      if (!this.data[key]) {
        this.data[key] = ' ';
      }
    }
    this.param = { ...this.data };
    if (this.data.asigfecha_alta) {
      const formatDate = moment(this.data.asigfecha_alta);
      this.param.asigfecha_alta = formatDate;
    }
  }
}
